module.exports = __webpack_public_path__ + "static/media/negocios.fdf25880.svg";